export default __webpack_public_path__ + "static/media/05-professional_thumb.27e46f91.png";